import { DeleteAppointment } from '~/domain/usecases/appointment/remote';
import { HttpClient, HttpStatusCode } from '~/data/protocols/http';
import {
  InvalidCredentialsError,
  UnexpectedError,
  BadRequestError,
} from '~/domain/errors';
import '~/infra/global/variables';

export class RemoteDeleteAppointment implements DeleteAppointment {
  private readonly url: string;

  private readonly httpClient: HttpClient<DeleteAppointment.Model>;

  constructor(url: string, httClient: HttpClient<DeleteAppointment.Model>) {
    this.url = url;
    this.httpClient = httClient;
  }

  delete = async (
    params: DeleteAppointment.Params,
  ): Promise<DeleteAppointment.Model> => {
    const httpResponse = await this.httpClient.request({
      url: `${this.url}/${params.id}`,
      method: 'delete',
    });
    switch (httpResponse.statusCode) {
      case HttpStatusCode.noContent:
        return httpResponse.body;
      case HttpStatusCode.badRequest:
        throw new BadRequestError();
      case HttpStatusCode.unauthorized:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError();
    }
  };
}
